function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.2465 8.03905L18.1398 8.02064C16.974 5.07788 14.1326 3 10.8123 3C6.78662 3 3.46482 6.05471 2.98018 10.002C2.91289 10.55 2.47763 11 1.93273 11H0.946111C0.401215 11 -0.045203 10.5508 0.00366539 10.0007C0.50179 4.39389 5.1508 -2.10734e-07 10.8123 0C14.7447 6.7435e-07 18.1885 2.11973 20.0923 5.29334L20.1053 2.4806C20.109 1.67041 20.76 1.01056 21.5594 1.00678C22.3587 1.003 23.0037 1.65672 23 2.46691L22.9681 9.38652C22.9644 10.1919 22.321 10.8488 21.5281 10.8602C21.3812 10.9117 21.2237 10.94 21.06 10.9407L14.233 10.973C13.4336 10.9768 12.7886 10.3231 12.7924 9.51288C12.7961 8.70269 13.4471 8.04283 14.2465 8.03905Z",
  fill: "currentColor"
});

var SvgSkipped = function SvgSkipped(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 23 11",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSkipped, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/skipped.c1f35eaa.svg";
export { ForwardRef as ReactComponent };